import Handlebars from './Handlebars';

export default Handlebars;
